import cn from "classnames";
import React, { Children, ReactElement, ReactNode, cloneElement, useCallback, useEffect, useState } from "react";
import styles from "./Tabs.module.scss";
type TabsProps = {
  cls?: string;
  children: Array<{
    props: {
      eventKey: string;
      children: ReactNode;
    };
  }>;
  defaultActiveKey: string | null;
  onSelect?: (eventKey: string) => void;
};
export default function Tabs(props: TabsProps) {
  const {
    children,
    defaultActiveKey,
    onSelect,
    cls
  } = props;
  const [activeKey, setActiveKey] = useState(defaultActiveKey);
  const activeContent = children?.find(child => child.props.eventKey === activeKey);
  const handleTabClick = useCallback((eventKey: string) => {
    setActiveKey(eventKey);
  }, [activeKey]);
  useEffect(() => {
    if (defaultActiveKey !== activeKey) setActiveKey(defaultActiveKey);
  }, [defaultActiveKey]);
  return <div className={cn(styles.tab_wrapper, {
    [styles[cls || ""]]: !!cls
  })} data-sentry-component="Tabs" data-sentry-source-file="Tabs.tsx">

      <ul className={styles.nav_tabs}>
        {Children.map(children, child => cloneElement(child as ReactElement, {
        handleTabClick,
        onSelect: () => onSelect ? onSelect(child.props.eventKey) : undefined,
        isActive: child.props.eventKey === activeKey
      }))}
      </ul>

      <div className="tab-container">{activeContent?.props.children}</div>
    </div>;
}
type Props = {
  title: string | ReactNode;
  eventKey: string;
  children: ReactNode;
  hoverTooltip?: string;
  [key: string]: any;
};
Tabs.Tab = function (props: Props) {
  const {
    title,
    eventKey,
    children,
    dataKey,
    ...rest
  } = props;
  function onClick() {
    rest.handleTabClick(eventKey);
    rest.onSelect();
  }
  return <li className={cn(styles.nav_item, "nav-item")} data-key={eventKey}>
      {rest.hoverTooltip && <div className={styles.hover_tooltip}>
          <span>{rest.hoverTooltip}</span>
        </div>}
      <button onClick={onClick} className={cn(styles.nav_link, {
      [styles.active]: rest.isActive,
      active: rest.isActive
    })}>
        {title}
      </button>
    </li>;
};